/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-05-14 09:39:48
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-08-15 11:27:41
 * @FilePath: \合联\oms\src\api\forecastManagement\subcontractForecastList.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取分包预报列表
export const getSubcontractForecastList = params => {
  return axios.request({
    url: "/warehouse/b2bUnpack/unpackForecast",
    method: "get",
    params
  });
};

//获取异常订单
export const getAbnormalOrder = params => {
  return axios.request({
    url: "/warehouse/b2bUnpack/getUnpackException",
    method: "get",
    params
  });
};

// 添加备注
export const addRemark = data => {
  return axios.request({
    url: "/warehouse/b2bUnpack/remarkInstruction",
    method: "post",
    data
  });
};

// 添加完成时间
export const addFinishTime = data => {
  return axios.request({
    url: "/warehouse/b2bUnpack/unpackComplete",
    method: "post",
    data
  });
};

// 服务类型
export const getServiceType = params => {
  return axios.request({
    url: "/doubleClearance/getService",
    method: "get",
    params
  });
};

// 获取拆包袋子订单
export const getBagOrder = params => {
  return axios.request({
    url: "/warehouse/b2bUnpack/getUnpackPackage",
    method: "get",
    params
  });
};

//查看箱单
export const getBoxOrder = params => {
  return axios.request({
    url: "/warehouse/b2bUnpack/getPackingList",
    method: "get",
    params
  });
};

// 添加指令文件
export const addInstructionFile = data => {
  return axios.request({
    url: "/warehouse/b2bUnpack/unpackInstructionLink",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  });
};

export const uploadSignSrc = data => {
  return axios.request({
    url: "/warehouse/b2bUnpack/uploadSignSrc",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  });
};



export const inTransitOrder = params => {
  return axios.request({
    url: `/warehouse/b2bUnpack/inTransitOrder/${params.airway_number}/${params.packing_number}`,
    method: "get",
    params
  });
};